import { dateLocale } from '../../utils/locale';

/** The list's Updated column ("Oct 1, 2026") and the preview's byline ("October 1, 2026"). */
const ARTICLE_DATE_FORMATS: Record<'short' | 'long', Intl.DateTimeFormatOptions> = {
  short: { month: 'short', day: 'numeric', year: 'numeric' },
  long: { month: 'long', day: 'numeric', year: 'numeric' },
};

/**
 * An article's date as the blog area prints it: in the UI language (the app's
 * language folder name, mapped by `dateLocale`) and the reader's own time zone.
 *
 * Not through moment: its global locale is whichever locale was defined last,
 * and the bets module defines Portuguese, so an English studio read
 * "out 1, 2026" for October 1st. A missing or unreadable date prints nothing
 * rather than "Invalid date" (`Intl` throws on one).
 */
export const formatArticleDate = (
  iso: string | null | undefined,
  appLanguage: string,
  style: 'short' | 'long',
): string => {
  if (!iso) return '';
  const ms = Date.parse(iso);
  if (!Number.isFinite(ms)) return '';
  return new Intl.DateTimeFormat(dateLocale(appLanguage), ARTICLE_DATE_FORMATS[style]).format(ms);
};
